import { formatDateTime } from '@pickleballinc/lib/format-dates';

import { publicEnv } from '@/lib/env';
import { MatchPropsShort } from '@/modules/results/types';

interface MatchHeaderProps {
  match: MatchPropsShort;
  isHistory?: boolean;
  setOpenMatchUUID: React.Dispatch<React.SetStateAction<string>>;
  pbracketsURL?: string;
}

export function MatchHeader({
  match,
  isHistory,
  setOpenMatchUUID,
  pbracketsURL,
}: MatchHeaderProps) {
  const bracketsURL = `${publicEnv.NEXT_PUBLIC_BRACKETS_URL}/tournaments/${match?.tournament_uuid}/events/${match?.event_uuid}/pools/${match?.pool_id}`;

  return (
    <div className='flex flex-col flex-wrap justify-between border-b p-2 sm:flex-row sm:items-center'>
      {isHistory ? (
        <div className='w-full text-sm text-gray-600'>
          {formatDateTime(match.match_completed, {
            timezoneAbbreviation: match.timezone_abbreviation,
            utcOffset: match.utc_offset,
          })}
        </div>
      ) : null}
      <h3 className='text-sm text-gray-600'>
        {isHistory ? <span>{match.tournament_title} </span> : null}
        {!isHistory && <span>{match.event_title}</span>}
      </h3>
      {isHistory ? <div className='w-full text-sm text-gray-600'>{match.event_title}</div> : null}
      {match.match_status === 2 ? (
        <div className='mr-2 flex w-[60px] items-center gap-1 rounded-2xl bg-error-600 px-3 py-1 sm:mr-0 sm:hidden'>
          <div className='size-1 animate-pulse rounded-full bg-white' />
          <div className='text-xs font-bold uppercase text-white'>Live</div>
        </div>
      ) : null}
      <div className='flex gap-3'>
        {match.match_status === 2 ? (
          <div className='mr-2 hidden items-center gap-1 rounded-2xl bg-error-600 px-3 py-1 sm:mr-0 sm:flex'>
            <div className='size-1 animate-pulse rounded-full bg-white' />
            <div className='text-xs font-bold uppercase text-white'>Live</div>
          </div>
        ) : null}
        <h5 className='rounded py-1 pr-2 text-sm text-gray-600 sm:text-left'>
          {match.match_number !== 0 && (
            <>
              <a
                href={pbracketsURL || bracketsURL}
                aria-label={`Link to view bracket for ${match?.tournament_title}`}
                className='cursor-pointer text-experiment underline'
              >
                <span>View Bracket</span>
              </a>
              <span> | </span>
            </>
          )}
          <span onClick={() => setOpenMatchUUID(match.match_uuid)} className='cursor-pointer'>
            <span className='hidden sm:inline'>Download Match Card</span>
            <span className='inline sm:hidden'>Download Card</span>
          </span>
          <span> | </span>
          {match.court_title !== '' && <span>Court {match.court_title}</span>}
          {match.court_title !== '' && match.match_number !== 0 && <span> | </span>}
          {match.match_number !== 0 && <span>Match {match.match_number} </span>}
        </h5>
      </div>
    </div>
  );
}
